<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <stores-icon-form/>
      </div>
    </div>
  </section>
</template>

<script>
import storesIconForm from './Temp/ChangeStoresIconTemp.vue'

export default {
  name: 'Tables',
  data () {
    return {
      info: {
        name: '光復店',
        des: '滿200外送'
      }
    }
  },
  components: {
    'stores-icon-form': storesIconForm
  },
  computed: {
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    }
  }
}
</script>



// WEBPACK FOOTER //
// ChangeStoresIcon.vue?5f04f295